import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServiceService } from '../../services/common/api-service.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
@Component({
  selector: 'app-post-requirement',
  templateUrl: './post-requirement.component.html',
  styleUrls: ['./post-requirement.component.scss']
})
export class PostRequirementComponent implements OnInit {
  leadForm!: FormGroup;
  categories: string[] = [];
  cities: any[] = [];
  
  constructor(
    private fb: FormBuilder,
    private apiService: ApiServiceService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.leadForm = this.fb.group({
      coupleName: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]{10}$'), Validators.maxLength(10)]],
      eventDate: ['', Validators.required],
      city: [null, Validators.required],
      categoriesNeeded: [[], Validators.required],
      budget: ['']
    });

    this.apiService.getCities().subscribe({
      next: (res: any) => {
        if(res && res.data) {
          // Map to just the city names using the correct property from the backend (city_nme)
          this.cities = res.data.map((c: any) => c.city_nme || c.city_name || c.name || c);
        } else if (Array.isArray(res)) {
          this.cities = res.map((c: any) => c.city_nme || c.city_name || c.name || c);
        }
      },
      error: (err: any) => {
        console.error('Error fetching cities', err);
        // Fallback cities just in case DB is empty or fails
        this.cities = ['Chennai', 'Coimbatore', 'Madurai', 'Trichy', 'Salem'];
      }
    });

    this.apiService.getServiceCategories().subscribe({
      next: (res: any) => {
        if (res && res.data) {
          this.categories = res.data.map((c: any) => c.name || c);
        }
      },
      error: (err: any) => {
        console.error('Error fetching categories', err);
        this.categories = ['Photography', 'Venue', 'Makeup', 'Catering', 'Decoration', 'Pandit'];
      }
    });
  }
  goBack(): void {
  this.location.back();
}

  onSubmit(): void {
    if (this.leadForm.valid) {
      this.apiService.postLead(this.leadForm.value).subscribe({
        next: (res: any) => {
          Swal.fire('Success', 'Your requirement has been posted! Matching vendors will contact you soon.', 'success');
          this.router.navigate(['/wedding-services/vendors']);
        },
        error: (err: any) => {
          Swal.fire('Error', 'Failed to post requirement', 'error');
        }
      });
    } else {
      this.leadForm.markAllAsTouched();
    }
  }
}
